import useValidation from '@/commons/validation'

export default {
  methods: {
    validationFormRule (field) {
      let rules = []
      switch (field) {
        case 'email':
          rules = [v => !!v || this.$tf('Email is required'),
            // v => /.+@.+\..+/.test(v) || this.$tf('Email must be valid'),
            // eslint-disable-next-line no-useless-escape,no-control-regex
            v => /(?:[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9](?:[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9-]*[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9])?\.)+[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9](?:[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9-]*[\u00A0-\uD7FF\uE000-\uFFFF-a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(v.toLowerCase()) || this.$tf('Email must be valid')]
          break
        case 'password':
          rules = [v => !!v || this.$tf('Password is required')]
          if (this.$serverConfig && this.$serverConfig.passwordValidations) {
            const { getRules } = useValidation(this.$i18n)
            rules.push(...getRules(this.$serverConfig.passwordValidations, 'validation.thePassword'))
          } else {
            rules.push(v => v.length >= 6 || this.$tf('Password must be at least 6 characters long'),
              v => v.length <= 40 || this.$tf('Password must be at most 40 characters long'))
          }
          break
        case 'firstname':
          rules = [v => !!v || this.$tf('Firstname is required'),
            v => v.length <= 100 || this.$tf('Firstname  must be at most 100 characters long')]
          break
        case 'lastname':
          rules = [v => !!v || this.$tf('Lastname is required'),
            v => v.length <= 100 || this.$tf('Lastname must be of at most 100 characters long')]
          break
        case 'repeatPassword' :
          rules = [v => !!v || this.$tf('Repeat your password'),
            v => v === this.password || this.$tf(`Passwords doesn't match`)]
          break
        case 'terms' :
          rules = [v => !!v || this.$tf('You must agree the legal notice and the privacy policy')]
          break
        case 'code' :
          rules = [v => !!v || this.$tf('Code is required')]
          break
        case 'message' :
          rules = [v => !!v || this.$tf('Message is required')]
          break
      }
      return rules
    }
  }
}
